import { AppContext } from "Core";

/**
 * Adds custom bindings for kendo-elements.
 * @hidden
 */
export class CustomBinding {
    /**
     * Initialize custom bindings.
     */
    public static initialize(): void {
        let kendoData = <any>kendo.data;

        let base = kendoData.binders.widget.source.fn._ns;
        let result: any;

        kendoData.binders.widget.source.fn._ns = function (ns: any) {
            return ns ? base.call(this, ns) : result || (result = base.call(this, ns));
        };

        //let animation = <any>kendo.ui.Menu.fn.options.animation;
        //animation.open.effects = "fadeIn";
        //animation = <any>kendo.ui.Popup.fn.options.animation;
        //animation.open.effects = "fadeIn";

        // cssClass-binding: enables binding to cssClasses in the model.
        kendoData.binders.cssClass = kendo.data.Binder.extend({
            refresh: function () {
                let value = this.bindings.cssClass.get(); // get the value from the binding

                let elem = $(this.element);

                // remove the previous set class
                let prevClass = elem.attr("data-dms-cssClass");
                if (prevClass && prevClass != value) {
                    elem.removeClass(prevClass);
                    elem.removeAttr("data-dms-cssClass");
                }

                if (value != null) {
                    // add class to the element and remember which classes were set with binding
                    elem.addClass(value);
                    elem.attr("data-dms-cssClass", value);
                }
            },
        });

        let typedBinder = kendo.data.Binder.extend({
            dataType: function () {
                let dataType = this.element.getAttribute("data-type") || this.element.type || "text";
                return dataType.toLowerCase();
            },
            parsedValue: function () {
                return this._parseValue(this.element.value, this.dataType());
            },
            _parseValue: function (value: any, dataType: string) {
                if (dataType == "date") {
                    value = kendo.parseDate(value, "yyyy-MM-dd");
                } else if (dataType == "datetime-local") {
                    value = kendo.parseDate(value, ["yyyy-MM-ddTHH:mm:ss", "yyyy-MM-ddTHH:mm"]);
                } else if (dataType == "number") {
                    value = kendo.parseFloat(value);
                } else if (dataType == "boolean") {
                    value = value.toLowerCase();
                    if (kendo.parseFloat(value) !== null) {
                        value = Boolean(kendo.parseFloat(value));
                    } else {
                        value = value.toLowerCase() === "true";
                    }
                }
                return value;
            },
        });

        // [name] is the name of the event "click", "mouseover", ..
        // same as you'd pass it to bind()
        // [fn] is the handler function
        (<any>$.fn).bindFirst = function (name: any, fn: any) {
            // bind as you normally would
            // don't want to miss out on any jQuery magic
            this.on(name, fn);

            // Thanks to a comment by @Martin, adding support for
            // namespaced events too.
            this.each(function () {
                let handlers = (<any>$)._data(this, "events")[name.split(".")[0]];
                // take out the handler we just inserted from the end
                let handler = handlers.pop();
                // move it at the beginning
                handlers.splice(0, 0, handler);
            });
        };

        kendoData.binders.input.checked = (<any>typedBinder).extend({
            init: function (element: HTMLElement, bindings: any, options: any) {
                (<any>typedBinder).fn.init.call(this, element, bindings, options);
                this._change = $.proxy(this.change, this);
                (<any>$(this.element)).bindFirst("change", this._change);
            },
            change: function () {
                let element = this.element;
                let value = this.value();
                if (element.type == "radio") {
                    value = this.parsedValue();
                    this.bindings["checked"].set(value);
                } else if (element.type == "checkbox") {
                    let source = this.bindings["checked"].get();
                    let index;
                    if (source instanceof kendo.data.ObservableArray) {
                        value = this.parsedValue();
                        if (value instanceof Date) {
                            for (let i = 0; i < source.length; i++) {
                                if (source[i] instanceof Date && +source[i] === +value) {
                                    index = i;
                                    break;
                                }
                            }
                        } else {
                            index = source.indexOf(value);
                        }
                        if (index > -1) {
                            source.splice(index, 1);
                        } else {
                            source.push(value);
                        }
                    } else {
                        this.bindings["checked"].set(value);
                    }
                }
            },
            refresh: function () {
                let value = this.bindings["checked"].get(),
                    source = value,
                    type = this.dataType(),
                    element = this.element;
                if (element.type == "checkbox") {
                    if (source instanceof kendo.data.ObservableArray) {
                        let index = -1;
                        value = this.parsedValue();
                        if (value instanceof Date) {
                            for (let i = 0; i < source.length; i++) {
                                if (source[i] instanceof Date && +source[i] === +value) {
                                    index = i;
                                    break;
                                }
                            }
                        } else {
                            index = source.indexOf(value);
                        }
                        element.checked = index >= 0;
                    } else {
                        element.checked = source;
                    }
                } else if (element.type == "radio" && value != null) {
                    if (type == "date") {
                        value = kendo.toString(value, "yyyy-MM-dd");
                    } else if (type == "datetime-local") {
                        value = kendo.toString(value, "yyyy-MM-ddTHH:mm:ss");
                    }
                    if (element.value === value.toString()) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                }
            },
            value: function () {
                let element = this.element,
                    value = element.value;
                if (element.type == "checkbox") {
                    value = element.checked;
                }
                return value;
            },
            destroy: function () {
                $(this.element).off("change", this._change);
            },
        });

        kendoData.binders.valueNull = kendo.data.Binder.extend({
            init: function (element: JQuery, bindings: any, options: any) {
                //call the base constructor
                kendo.data.Binder.fn.init.call(this, element, bindings, options);

                let that = this;
                //listen for the change event of the element
                (<any>$(that.element)).bindFirst("change", function () {
                    that.change(); //call the change function
                });
            },
            refresh: function () {
                let value = this.bindings.valueNull.get(); //get the value from the View-Model
                $(this.element).val(value); //update the HTML input element
            },
            change: function () {
                let value = $(this.element).val();
                if (value == "") {
                    value = null;
                }
                this.bindings.valueNull.set(value); //update the View-Model
            },
        });

        kendoData.binders.widget.cssClass = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
            },
            refresh: function () {
                let value = this.bindings.cssClass.get(); // get the value from the binding

                let widget = <kendo.ui.Widget>this.widget;

                // remove the previous set class
                let prevClass = widget.element.attr("data-dms-cssClass");
                if (prevClass && prevClass != value) {
                    widget.element.removeClass(prevClass);
                    widget.element.removeAttr("data-dms-cssClass");
                }

                if (value != null) {
                    // add class to the element and remember which classes were set with binding
                    widget.element.addClass(value);
                    widget.element.attr("data-dms-cssClass", value);
                }
            },
        });

        // this custom date binding resolves issues with timezone conversion
        // the new binding converts the value to match the server timezone and sets the time to 00:00
        kendoData.binders.widget.customDate = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                // if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {
                if (!this._initChange) {
                    let value = this.bindings.customDate.get();
                    if (value) {
                        if (!(value instanceof Date)) {
                            value = new Date(value);
                        }
                        value = kendo.timezone.convert(value, AppContext.current.environment.ClientTimeZone, "Etc/UTC");
                        value = new Date(value.getFullYear(), value.getMonth(), value.getDate());
                        this.widget.value(value);
                    } else {
                        this.widget.value(null);
                    }
                }
            },
            change: function () {
                this._initChange = true;

                let val = this.widget.value();
                if (val) {
                    val = new Date(val.getFullYear(), val.getMonth(), val.getDate());
                    val = kendo.timezone.convert(val, "Etc/UTC", AppContext.current.environment.ClientTimeZone);
                }

                this.bindings.customDate.set(val || null);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        kendoData.binders.widget.customDateNoTimeZone = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                // if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {
                if (!this._initChange) {
                    let value = this.bindings.customDateNoTimeZone.get();
                    if (value) {
                        if (!(value instanceof Date)) {
                            value = new Date(value);
                        }
                        value = kendo.timezone.convert(
                            value,
                            AppContext.current.environment.ClientTimeZone,
                            AppContext.current.environment.ServerTimeZone
                        );
                        this.widget.value(value);
                    } else {
                        this.widget.value(null);
                    }
                }
            },
            change: function () {
                this._initChange = true;

                let val = this.widget.value();
                if (val) {
                    val = kendo.timezone.convert(
                        val,
                        AppContext.current.environment.ServerTimeZone,
                        AppContext.current.environment.ClientTimeZone
                    );
                }

                this.bindings.customDateNoTimeZone.set(val || null);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        kendoData.binders.widget.deferredValue = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                // if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {
                if (!this._initChange) {
                    let widget = <kendo.ui.ComboBox>this.widget;
                    let value = this.bindings.deferredValue.get();

                    if (widget.dataSource.data().length == 0) {
                        if (value != null) {
                            if (widget.options.autoBind === false) {
                                //widget.element.val(value);
                                //widget.input.val("xx");

                                //Bind the widget with single item if deffered binding is used
                                //widget.dataSource.add([{ [widget.options.dataValueField]: value, [widget.options.dataTextField]: "" }])
                                widget.dataSource.data([{ [widget.options.dataValueField]: value, [widget.options.dataTextField]: "" }]);
                                widget.value(value);
                            } else {
                                //set widget value directly
                                this.widget.value(value);
                            }
                        }
                    } else {
                        this.widget.value(value);
                    }
                }
            },
            change: function () {
                this._initChange = true;
                this.bindings.deferredValue.set(this.widget.value() || null);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        // this binding is used when data from multiselects are loaded via editcontext.
        // when the initial value is bound, the control gets an dummy datasource which holds the current value and an empty text
        // after the data is loaded via editcontext, the datasource gets updated (code is in control).
        kendoData.binders.widget.deferredMultiSelectValue = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                // if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {
                if (!this._initChange) {
                    let widget = <kendo.ui.MultiSelect>this.widget;
                    let value = this.bindings.deferredMultiSelectValue.get();

                    if (widget.dataSource.data().length == 0) {
                        if (value != null) {
                            let data = CustomBinding.convertStringToArray(
                                value,
                                widget.options.dataValueField,
                                widget.options.dataTextField,
                                (<any>this.widget.options).separator
                            );
                            if (widget.options.autoBind === false) {
                                widget.dataSource.data(data.data);
                                this.widget.value(data.valueAsArray);
                            } else {
                                this.widget.value(data.valueAsArray);
                            }
                        }
                    } else {
                        this.widget.value(value);
                    }
                }
            },
            change: function () {
                this._initChange = true;
                let value = CustomBinding.convertArrayToString(this.widget.value(), (<any>this.widget.options).separator);
                this.bindings.deferredMultiSelectValue.set(value);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        // this binding is used when data from multiselects are loaded via editcontext.
        // when the initial value is bound, the control gets an dummy datasource which holds the current value and an empty text
        // after the data is loaded via editcontext, the datasource gets updated (code is in control).
        kendoData.binders.widget.deferredMultiSelectValueAsync = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                // if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {
                if (!this._initChange) {
                    let widget = <kendo.ui.MultiSelect>this.widget;
                    let value = this.bindings.deferredMultiSelectValueAsync.get();

                    if (widget.dataSource.data().length == 0) {
                        if (value != null) {
                            let data = CustomBinding.convertStringToArray(
                                value,
                                widget.options.dataValueField,
                                widget.options.dataTextField,
                                (<any>widget.options).separator
                            );

                            if (widget.options.autoBind === false) {
                                widget.dataSource.data(data.data);
                                widget.element.val(data.valueAsArray);
                                widget.value(data.valueAsArray);
                            } else {
                                this.widget.value(data.valueAsArray);
                            }
                        }
                    } else {
                        this.widget.value(value);
                    }
                }
            },
            change: function () {
                this._initChange = true;
                let value = CustomBinding.convertArrayToString(this.widget.value(), (<any>this.widget.options).separator);
                this.bindings.deferredMultiSelectValueAsync.set(value);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        // this binding is used when data from comboboxes are loaded via editcontext.
        // when the initial value is bound, the control gets an dummy datasource which holds the current value and an empty text
        // after the data is loaded via editcontext, the datasource gets updated (code is in control).
        kendoData.binders.widget.deferredValueAsync = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                // if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {
                if (!this._initChange) {
                    let widget = <kendo.ui.ComboBox>this.widget;
                    let value = this.bindings.deferredValueAsync.get();

                    if (value != null) {
                        if (widget.options.autoBind === false) {
                            widget.element.val(value);
                            widget.input.val("");
                        } else {
                            //set widget value directly
                            this.widget.value(value);
                        }
                    }
                }
            },
            change: function () {
                this._initChange = true;
                this.bindings.deferredValueAsync.set(this.widget.value() || null);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        // binds the text property for lists.
        kendoData.binders.widget.listText = kendo.data.Binder.extend({
            init: function (widget: kendo.ui.Widget, bindings: any, options: any) {
                kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                this.widget = widget;
                this._change = $.proxy(this.change, this);

                //if the control already has change-events registered, we need to insert this event on first position
                if (this.widget._events["change"] !== undefined) {
                    this.widget._events["change"].unshift(this._change);
                } else {
                    // otherwise just bind the event
                    this.widget.bind("change", this._change);
                }
            },
            refresh: function () {},
            change: function () {
                this._initChange = true;
                this.bindings.listText.set(this.widget.text() || null);
                this._initChange = false;
            },
            destroy: function () {
                this.widget.unbind("change", this._change);
            },
        });

        // threestatechecked-binding: enables binding for threestatecheckbox.
        kendoData.binders.threestatechecked = kendo.data.Binder.extend({
            init: function (element: JQuery, bindings: any, options: any) {
                //call the base constructor
                kendo.data.Binder.fn.init.call(this, element, bindings, options);

                let that = this;
                //listen for the change event of the element
                $(that.element).on("change", function () {
                    that.change(); //call the change function
                });
            },
            refresh: function () {
                if (!this._initChange) {
                    let value = this.bindings.threestatechecked.get(); // get the value from the binding
                    let elem = $(this.element);

                    if (value == true) {
                        elem.data("checked", 2);
                        elem.prop("indeterminate", false);
                        elem.prop("checked", true);
                    } else if (value == false) {
                        elem.data("checked", 0);
                        elem.prop("indeterminate", false);
                        elem.prop("checked", false);
                    } else {
                        elem.data("checked", 1);
                        elem.prop("indeterminate", true);
                        elem.prop("checked", false);
                    }
                }
            },
            change: function () {
                let elem = $(this.element);
                if (elem.data("TRIGGERCHANGE") === true) {
                    this._initChange = true;
                    let isNull = elem.prop("indeterminate");
                    if (isNull) {
                        this.bindings.threestatechecked.set(null);
                    } else {
                        let value = elem.is(":checked");
                        this.bindings.threestatechecked.set(value);
                    }
                    this._initChange = false;
                }
            },
            destroy: function () {
                let elem = $(this.element);
                elem.off("change", this.change);
            },
        });
    }

    private static convertArrayToString(value: string[], separator: string): string {
        let newValue: string = null;
        if ((value && value.length == 0) || !value) {
            newValue = null;
        } else {
            newValue = value.join(separator);
        }
        return newValue;
    }

    private static convertStringToArray(
        input: string,
        dataValueField: string,
        dataTextField: string,
        separator: string
    ): { data: object[]; valueAsArray: string[] } {
        let data = [];
        let value = input.split(separator);
        let valueAsArray = [];
        for (let i = 0, len = value.length; i < len; i++) {
            let obj = { [dataValueField]: value[i] };
            if (dataTextField != dataValueField) {
                obj.dataTextField = "&nbsp;";
            }
            data.push(obj);
            valueAsArray.push(value[i]);
        }
        return {
            data: data,
            valueAsArray: valueAsArray,
        };
    }
}
